var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",style:(_vm.styles.image),on:{"click":function (e) { return _vm.$emit('click', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }